// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1081":"a5de2152","2237":"a5de2152","3119":"a5de2152","3918":"a5de2152","4714":"235fc102","8646":"a5de2152","8973":"9558e8c9"}[chunkId] + ".chunk.css";
};